import { ThreatContainer, Banner, TextContainer } from './threat.styles';
import { Link } from 'react-router-dom';

export const ThreatValidation = () => {
  return (
    <ThreatContainer>
      <Banner>
        <h2>Validación de información</h2>
      </Banner>
      <TextContainer>
        <h2>
          El equipo de Finsphera está realizando una validación de los datos que nos proporcionaste.
        </h2>
        <p>
          Si tienes alguna duda contáctanos en:{' '}
          <Link to="mailto:atencionaclientes@finsphera.com">atencionaclientes@finsphera.com</Link>
        </p>
      </TextContainer>
    </ThreatContainer>
  );
};
